import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=87093434&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QTooltip,QDrawer,QScrollArea,QList,QSeparator,QPageContainer,QPage} from 'quasar'
component.options.components = Object.assign({QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QTooltip,QDrawer,QScrollArea,QList,QSeparator,QPageContainer,QPage}, component.options.components || {})
